enum LINK {
  PRIVACY = 'privacy',
  PASSWORD_HELP = 'passwordHelp',
}

export { LINK }
